export default function ContactStatusBadge({ status }) {
  if (!status) return null;
  const label = status.replaceAll('_', ' ');
  return (
    <span className={`inline-flex shrink-0 items-center rounded px-2 py-1 text-xs font-medium capitalize ${status === 'approved' ? 'bg-emerald-50 text-emerald-800' : 'bg-slate-100 text-slate-600'}`}>
      {label.charAt(0).toUpperCase() + label.slice(1)}
    </span>
  );
}
